<template>
	<div class="textCenter" >
		<Loading :isLoading="true"  ></Loading>
	</div>
</template>
<script>
	import Loading from './../../common/cmpnt/Loading/Loading.vue'//缓冲
	// 酒店详情中转页
	export default{
		name:"hotelTemp",
		components:{
			Loading
		},
		methods:{
			//打开详情
            routeToDetails(info){
                var obj={
                	CityName:info.CityName,
                    HotelID:info.HotelID,
                    From:info.From,
                    CheckIn: info.CheckIn,
        						CheckOut: info.CheckOut,
                    RoomCount:1,
                    AdultCount:2,
                    ChildrenCount:0,
                    ChildrenAges:[],
                    MyLat:'',
                    MyLon:'',
                    MyCityRegionID:'',
                }
                this.dao.set('hotelDetailsParams',obj);
                this.$router.push('/hotelDetails');
            },
		},


		mounted(){
		
			var info=this.dao.get('hotelTempInfo');
			var lastid=this.dao.get('lastHotelTempId')||'';

			if(lastid==info.HotelID&&this.$route.query.from=='hotelList'){
				this.$router.push('/hotelList');
			}else{
				this.dao.set('lastHotelTempId',info.HotelID)
				this.routeToDetails(info);
			}
			
		}

	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/hotelTemp.vue